import { connect } from 'react-redux'
import {
  closeKindModal,
} from '../actions'
import RouteMapKindModal from '../components/route_maps/RouteMapKindModal'

const mapStateToProps = state => {
  const { themeName } = state.themeReducer

  return {
    themeName,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeKindModal: () => {
      dispatch(closeKindModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RouteMapKindModal)
